import ResumePoints from './ResumePoints';
import resolveResumePointsActions from './resolveResumePointsActions';
import StoreName from '../Shared/Constants/StoreName';

const createResumePointsStore = state =>
    state.createStore({
        name: StoreName.RESUME_POINTS,
        model: ResumePoints,
        actions: resolveResumePointsActions,
        emitOnSubscription: false,
    });

export default createResumePointsStore;
